import { FieldPropsConfig } from 'ui/forms/custom/types';

import { commonFieldsProps } from '../common/fields';

import { inStates } from './states';

export const INFieldProps: Record<string, FieldPropsConfig> = {
  ...commonFieldsProps,
  firstName: {
    fieldType: 'input',
    validations: ['name'],
    maxLength: 50,
  },
  lastName: {
    fieldType: 'input',
    validations: ['name'],
    maxLength: 50,
  },
  password: {
    fieldType: 'password',
    validations: ['password'],
    minLength: 8,
    maxLength: 255,
  },
  gender: {
    fieldType: 'input-radio',
    values: ['male', 'female'],
  },
  phone: {
    fieldType: 'input',
    prefix: '+91',
    validations: ['phoneNumber'],
  },
  countryCode: {
    fieldType: 'dropdown',
    validations: [],
    disabled: true,
    options: [{ label: 'India', value: 'IN' }],
  },
  postalCode: {
    fieldType: 'pincode',
    mapAddressLookupResultsToFormValues: [
      { resultKey: 'stateCode', formKey: 'stateCode' },
      { resultKey: 'street', formKey: 'address1' },
      { resultKey: 'city', formKey: 'city' },
    ],
    minLength: 6,
    maxLength: 6,
    validations: ['postalCode'],
  },
  stateCode: {
    fieldType: 'dropdown',
    options: inStates.map(state => ({ value: state.value, label: state.name })),
  },
  address1: {
    fieldType: 'google-address-look-up',
    mapAddressLookupResultsToFormValues: [
      { resultKey: 'stateCode', formKey: 'stateCode' },
      { resultKey: 'address1', formKey: 'address1' },
      { resultKey: 'city', formKey: 'city' },
      { resultKey: 'postalCode', formKey: 'postalCode' },
    ],
    validateOnAddressLookupSelect: false,
    maxLength: 50,
    submitOnUpdate: false,
    validations: ['addressLine1'],
  },
  address2: {
    fieldType: 'input',
    validations: ['addressLine2'],
    maxLength: 50,
  },
};
